/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DocBits - API
 * DocBits - API
 * OpenAPI spec version: 11.97.2
 */
import type {
  AssignTaskToGroupTasksAndNotificationsTasksTaskIdAssignGroupGroupIdPostParams,
  AssignTaskToUserTasksAndNotificationsTasksTaskIdAssignUserUserIdPostParams,
  BodyBulkDeleteTasksTasksAndNotificationsTasksDelete,
  BodyBulkUpdateTaskStatusTasksAndNotificationsTasksStatusPatch,
  DeleteNotificationTasksAndNotificationsNotificationsNotificationIdDeleteParams,
  DeleteTaskTasksAndNotificationsTasksByIdTaskIdDeleteParams,
  GetTaskTasksAndNotificationsTasksByIdTaskIdGetParams,
  GetTasksCachesTasksAndNotificationsTasksCachesGetBody,
  GetTasksCachesTasksAndNotificationsTasksCachesGetParams,
  GetTasksTasksAndNotificationsTasksGetBody,
  GetTasksTasksAndNotificationsTasksGetParams,
  GetTasksTotalCountTasksAndNotificationsTasksTotalCountGetBody,
  GetTasksTotalCountTasksAndNotificationsTasksTotalCountGetParams,
  NotificationCreate,
  NotificationUpdate,
  NotificationUpdateFields,
  NotificationsListTasksAndNotificationsNotificationsGetParams,
  TaskCreate,
  TaskUpdate,
  TaskUpdateFields,
} from '.././models';

import { customAxiosInstance } from '../../mutator/custom-axios-instance';

export const getTasksAndNotifications = () => {
  /**
   * @summary Get Tasks
   */
  const getTasksTasksAndNotificationsTasksGet = (
    getTasksTasksAndNotificationsTasksGetBody: GetTasksTasksAndNotificationsTasksGetBody,
    params?: GetTasksTasksAndNotificationsTasksGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/tasks_and_notifications/tasks`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      params,
    });
  };
  /**
   * @summary Create Task
   */
  const createTaskTasksAndNotificationsTasksPost = (taskCreate: TaskCreate) => {
    return customAxiosInstance<unknown>({
      url: `/tasks_and_notifications/tasks`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: taskCreate,
    });
  };
  /**
   * @summary Bulk Delete Tasks
   */
  const bulkDeleteTasksTasksAndNotificationsTasksDelete = (
    bodyBulkDeleteTasksTasksAndNotificationsTasksDelete: BodyBulkDeleteTasksTasksAndNotificationsTasksDelete,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    bodyBulkDeleteTasksTasksAndNotificationsTasksDelete.task_ids.forEach(
      (value) => formUrlEncoded.append(`task_ids`, value),
    );
    formUrlEncoded.append(
      `org_id`,
      bodyBulkDeleteTasksTasksAndNotificationsTasksDelete.org_id,
    );

    return customAxiosInstance<unknown>({
      url: `/tasks_and_notifications/tasks`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Get Tasks Caches
   */
  const getTasksCachesTasksAndNotificationsTasksCachesGet = (
    getTasksCachesTasksAndNotificationsTasksCachesGetBody: GetTasksCachesTasksAndNotificationsTasksCachesGetBody,
    params?: GetTasksCachesTasksAndNotificationsTasksCachesGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/tasks_and_notifications/tasks_caches/`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      params,
    });
  };
  /**
   * @summary Get Tasks Total Count
   */
  const getTasksTotalCountTasksAndNotificationsTasksTotalCountGet = (
    getTasksTotalCountTasksAndNotificationsTasksTotalCountGetBody: GetTasksTotalCountTasksAndNotificationsTasksTotalCountGetBody,
    params?: GetTasksTotalCountTasksAndNotificationsTasksTotalCountGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/tasks_and_notifications/tasks_total_count`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      params,
    });
  };
  /**
   * @summary Get Task
   */
  const getTaskTasksAndNotificationsTasksByIdTaskIdGet = (
    taskId: string,
    params: GetTaskTasksAndNotificationsTasksByIdTaskIdGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/tasks_and_notifications/tasks/by-id/${taskId}`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Update Task
   */
  const updateTaskTasksAndNotificationsTasksByIdTaskIdPut = (
    taskId: string,
    taskUpdate: TaskUpdate,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/tasks_and_notifications/tasks/by-id/${taskId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: taskUpdate,
    });
  };
  /**
   * @summary Patch Task
   */
  const patchTaskTasksAndNotificationsTasksByIdTaskIdPatch = (
    taskId: string,
    taskUpdateFields: TaskUpdateFields,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/tasks_and_notifications/tasks/by-id/${taskId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: taskUpdateFields,
    });
  };
  /**
   * @summary Delete Task
   */
  const deleteTaskTasksAndNotificationsTasksByIdTaskIdDelete = (
    taskId: string,
    params: DeleteTaskTasksAndNotificationsTasksByIdTaskIdDeleteParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/tasks_and_notifications/tasks/by-id/${taskId}`,
      method: 'DELETE',
      params,
    });
  };
  /**
   * @summary Bulk Update Task Status
   */
  const bulkUpdateTaskStatusTasksAndNotificationsTasksStatusPatch = (
    bodyBulkUpdateTaskStatusTasksAndNotificationsTasksStatusPatch: BodyBulkUpdateTaskStatusTasksAndNotificationsTasksStatusPatch,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    bodyBulkUpdateTaskStatusTasksAndNotificationsTasksStatusPatch.task_ids.forEach(
      (value) => formUrlEncoded.append(`task_ids`, value),
    );
    formUrlEncoded.append(
      `org_id`,
      bodyBulkUpdateTaskStatusTasksAndNotificationsTasksStatusPatch.org_id,
    );
    formUrlEncoded.append(
      `status`,
      bodyBulkUpdateTaskStatusTasksAndNotificationsTasksStatusPatch.status,
    );

    return customAxiosInstance<unknown>({
      url: `/tasks_and_notifications/tasks/status`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Assign Task To User
   */
  const assignTaskToUserTasksAndNotificationsTasksTaskIdAssignUserUserIdPost = (
    taskId: string,
    userId: number,
    params: AssignTaskToUserTasksAndNotificationsTasksTaskIdAssignUserUserIdPostParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/tasks_and_notifications/tasks/${taskId}/assign/user/${userId}`,
      method: 'POST',
      params,
    });
  };
  /**
   * @summary Assign Task To Group
   */
  const assignTaskToGroupTasksAndNotificationsTasksTaskIdAssignGroupGroupIdPost =
    (
      taskId: string,
      groupId: string,
      params: AssignTaskToGroupTasksAndNotificationsTasksTaskIdAssignGroupGroupIdPostParams,
    ) => {
      return customAxiosInstance<unknown>({
        url: `/tasks_and_notifications/tasks/${taskId}/assign/group/${groupId}`,
        method: 'POST',
        params,
      });
    };
  /**
   * @summary Notifications List
   */
  const notificationsListTasksAndNotificationsNotificationsGet = (
    params?: NotificationsListTasksAndNotificationsNotificationsGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/tasks_and_notifications/notifications`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Create Notification
   */
  const createNotificationTasksAndNotificationsNotificationsPost = (
    notificationCreate: NotificationCreate,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/tasks_and_notifications/notifications`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: notificationCreate,
    });
  };
  /**
   * @summary Update Notification
   */
  const updateNotificationTasksAndNotificationsNotificationsNotificationIdPut =
    (notificationId: string, notificationUpdate: NotificationUpdate) => {
      return customAxiosInstance<unknown>({
        url: `/tasks_and_notifications/notifications/${notificationId}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: notificationUpdate,
      });
    };
  /**
   * @summary Patch Notification
   */
  const patchNotificationTasksAndNotificationsNotificationsNotificationIdPatch =
    (
      notificationId: string,
      notificationUpdateFields: NotificationUpdateFields,
    ) => {
      return customAxiosInstance<unknown>({
        url: `/tasks_and_notifications/notifications/${notificationId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: notificationUpdateFields,
      });
    };
  /**
   * @summary Delete Notification
   */
  const deleteNotificationTasksAndNotificationsNotificationsNotificationIdDelete =
    (
      notificationId: string,
      params: DeleteNotificationTasksAndNotificationsNotificationsNotificationIdDeleteParams,
    ) => {
      return customAxiosInstance<unknown>({
        url: `/tasks_and_notifications/notifications/${notificationId}`,
        method: 'DELETE',
        params,
      });
    };
  return {
    getTasksTasksAndNotificationsTasksGet,
    createTaskTasksAndNotificationsTasksPost,
    bulkDeleteTasksTasksAndNotificationsTasksDelete,
    getTasksCachesTasksAndNotificationsTasksCachesGet,
    getTasksTotalCountTasksAndNotificationsTasksTotalCountGet,
    getTaskTasksAndNotificationsTasksByIdTaskIdGet,
    updateTaskTasksAndNotificationsTasksByIdTaskIdPut,
    patchTaskTasksAndNotificationsTasksByIdTaskIdPatch,
    deleteTaskTasksAndNotificationsTasksByIdTaskIdDelete,
    bulkUpdateTaskStatusTasksAndNotificationsTasksStatusPatch,
    assignTaskToUserTasksAndNotificationsTasksTaskIdAssignUserUserIdPost,
    assignTaskToGroupTasksAndNotificationsTasksTaskIdAssignGroupGroupIdPost,
    notificationsListTasksAndNotificationsNotificationsGet,
    createNotificationTasksAndNotificationsNotificationsPost,
    updateNotificationTasksAndNotificationsNotificationsNotificationIdPut,
    patchNotificationTasksAndNotificationsNotificationsNotificationIdPatch,
    deleteNotificationTasksAndNotificationsNotificationsNotificationIdDelete,
  };
};
export type GetTasksTasksAndNotificationsTasksGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getTasksAndNotifications
      >['getTasksTasksAndNotificationsTasksGet']
    >
  >
>;
export type CreateTaskTasksAndNotificationsTasksPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getTasksAndNotifications
      >['createTaskTasksAndNotificationsTasksPost']
    >
  >
>;
export type BulkDeleteTasksTasksAndNotificationsTasksDeleteResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getTasksAndNotifications
      >['bulkDeleteTasksTasksAndNotificationsTasksDelete']
    >
  >
>;
export type GetTasksCachesTasksAndNotificationsTasksCachesGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getTasksAndNotifications
        >['getTasksCachesTasksAndNotificationsTasksCachesGet']
      >
    >
  >;
export type GetTasksTotalCountTasksAndNotificationsTasksTotalCountGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getTasksAndNotifications
        >['getTasksTotalCountTasksAndNotificationsTasksTotalCountGet']
      >
    >
  >;
export type GetTaskTasksAndNotificationsTasksByIdTaskIdGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getTasksAndNotifications
      >['getTaskTasksAndNotificationsTasksByIdTaskIdGet']
    >
  >
>;
export type UpdateTaskTasksAndNotificationsTasksByIdTaskIdPutResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getTasksAndNotifications
        >['updateTaskTasksAndNotificationsTasksByIdTaskIdPut']
      >
    >
  >;
export type PatchTaskTasksAndNotificationsTasksByIdTaskIdPatchResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getTasksAndNotifications
        >['patchTaskTasksAndNotificationsTasksByIdTaskIdPatch']
      >
    >
  >;
export type DeleteTaskTasksAndNotificationsTasksByIdTaskIdDeleteResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getTasksAndNotifications
        >['deleteTaskTasksAndNotificationsTasksByIdTaskIdDelete']
      >
    >
  >;
export type BulkUpdateTaskStatusTasksAndNotificationsTasksStatusPatchResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getTasksAndNotifications
        >['bulkUpdateTaskStatusTasksAndNotificationsTasksStatusPatch']
      >
    >
  >;
export type AssignTaskToUserTasksAndNotificationsTasksTaskIdAssignUserUserIdPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getTasksAndNotifications
        >['assignTaskToUserTasksAndNotificationsTasksTaskIdAssignUserUserIdPost']
      >
    >
  >;
export type AssignTaskToGroupTasksAndNotificationsTasksTaskIdAssignGroupGroupIdPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getTasksAndNotifications
        >['assignTaskToGroupTasksAndNotificationsTasksTaskIdAssignGroupGroupIdPost']
      >
    >
  >;
export type NotificationsListTasksAndNotificationsNotificationsGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getTasksAndNotifications
        >['notificationsListTasksAndNotificationsNotificationsGet']
      >
    >
  >;
export type CreateNotificationTasksAndNotificationsNotificationsPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getTasksAndNotifications
        >['createNotificationTasksAndNotificationsNotificationsPost']
      >
    >
  >;
export type UpdateNotificationTasksAndNotificationsNotificationsNotificationIdPutResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getTasksAndNotifications
        >['updateNotificationTasksAndNotificationsNotificationsNotificationIdPut']
      >
    >
  >;
export type PatchNotificationTasksAndNotificationsNotificationsNotificationIdPatchResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getTasksAndNotifications
        >['patchNotificationTasksAndNotificationsNotificationsNotificationIdPatch']
      >
    >
  >;
export type DeleteNotificationTasksAndNotificationsNotificationsNotificationIdDeleteResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getTasksAndNotifications
        >['deleteNotificationTasksAndNotificationsNotificationsNotificationIdDelete']
      >
    >
  >;
